var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('page-header',{attrs:{"root-location":{ name: _vm.$routes.ProjectIntegrationConversation, params: _vm.$route.params },"breadcrumb-name-override-map":{ [_vm.$routes.ProjectPlatformWhatsApp]: 'WhatsApp' }}}),_c('whatsapp-settings-card',{attrs:{"bot":_vm.bot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }